import { useMemo, useState } from 'react'

import { useMemoizedFn, useUpdateEffect } from 'ahooks'

import { useSelfLoadingProps } from './interface'

export const useSelfLoading = ({ loading, onClick }: useSelfLoadingProps) => {
  const [selfClicked, setSelfClicked] = useState(false)

  const handleClick = useMemoizedFn(e => {
    setSelfClicked(true)
    onClick?.(e)
  })

  // 当 loading 从 true 变为 false 时，清除 selfClicked 标记
  useUpdateEffect(() => {
    if (!loading && selfClicked) {
      setSelfClicked(false)
    }
  }, [loading])

  const finalLoading = useMemo(
    () => (loading && selfClicked ? loading : false),
    [loading, selfClicked]
  )

  return {
    loading: finalLoading,
    onClick: handleClick
  }
}
